export const BASE_URL = "https://newpay.infn.dev/api/admin";

export const stores_url = BASE_URL + '/stores/dropdowns'
export const fields_url = BASE_URL + '/scrapingRules/fields'
export const elements_url = BASE_URL + '/scrapingRules/elements'

// export const stores_url = 'https://newpay.infn.dev/api/admin/stores/dropdowns'
// export const fields_url = 'https://newpay.infn.dev/api/admin/scrapingRules/fields'
// export const elements_url = 'https://newpay.infn.dev/api/admin/scrapingRules/elements'
